import { changeElementPositionInArray } from 'utils/list';
import { VideoTemplateStateContent } from '../../types';
import { getActiveLayers } from './selectors';
import { LayerMoveOption } from './types';

function findNextIndexForward(
  originalLayers: string[],
  activeLayers: string[],
  startIndex: number,
): number {
  const reversedLayers = originalLayers.slice(0, startIndex).reverse();
  const nextIndex = reversedLayers.findIndex(layer =>
    activeLayers.includes(layer),
  );

  return nextIndex !== -1 ? startIndex - nextIndex - 1 : 0;
}

function findNextIndexBackward(
  originalLayers: string[],
  activeLayers: string[],
  startIndex: number,
): number {
  const nextIndex = originalLayers
    .slice(startIndex + 1)
    .findIndex(layer => activeLayers.includes(layer));

  return nextIndex !== -1
    ? nextIndex + startIndex + 1
    : originalLayers.length - 1;
}

function getNewLayerIndex(
  state: VideoTemplateStateContent,
  layerIndex: number,
  moveTo: LayerMoveOption,
): number {
  const originalLayers = state.layers.order;
  const activeLayers = getActiveLayers(state);

  switch (moveTo) {
    case 'front': {
      return 0;
    }

    case 'forward': {
      return findNextIndexForward(originalLayers, activeLayers, layerIndex);
    }

    case 'backward': {
      return findNextIndexBackward(originalLayers, activeLayers, layerIndex);
    }

    case 'back': {
      return originalLayers.length - 1;
    }

    default: {
      return layerIndex;
    }
  }
}

export function moveLayer(
  state: VideoTemplateStateContent,
  layerId: string,
  moveTo: LayerMoveOption,
): string[] {
  const originalLayers = state?.layers?.order;
  const currentLayerIndex = originalLayers.indexOf(layerId);
  const destinationIndex = getNewLayerIndex(state, currentLayerIndex, moveTo);

  return changeElementPositionInArray(
    originalLayers,
    currentLayerIndex,
    destinationIndex,
  );
}
